import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Col,
} from "react-bootstrap";
import ToggleButton from "react-toggle-button";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { helperFunctions as HF } from '../../../helper/helperFunctions';
import { themeCSSConstants } from 'redux/constant/themeCSS';
import { confirmAlert } from 'react-confirm-alert';
import ConfirmAlert from '../../ThemeComponents/confirmAlert';
import { FiEye } from 'react-icons/fi'
import { hasPermission } from 'helper/hasPermission';
import Select from 'react-select';
import { brandActions } from "../../../redux/actions/brand-actions";
import { brandService } from "../../../services/brand";
import { alertActions } from "../../../redux/actions/alert-actions";
import DatePicker from 'react-date-picker';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import SimpleReactValidator from 'simple-react-validator';

var moment = require("moment");
var cloneDeep = require('lodash.clonedeep');
const format = 'HH:mm';

const now = moment().hour(0).minute(0);
const timeTypes = [
    {
        value: "minutes",
        label: "Minutes"
    },
    {
        value: "hours",
        label: "Hours"
    },
]

class SFTP_Configuration extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            user_name: '',
            password: '',
            password_type: 'password',
            short_code: '',
            sync_is_active: {
                id: '',
                value: false
            },
            update_file_extension: {
                id: '',
                value: false
            },
            truncate_before_syncing: {
                id: '',
                value: false
            },
            syncing_lookup_tables: {
                id: '',
                value: false
            },
            syncTime: {
                time_duration: '',
                duration_type: '',
                syncDateUTC: '',
                syncDateLocale: null,
                startTimeLocale: null,
                syncDateTimeUtc: moment('10:00', "hh:mm")
            }
        }
    }

    handleInput = e => {
        const { name, value } = e.target;
        this.setState({
            ...this.state,
            [name]: value,
        })
    }

    returnSftpState = () => {
        return { ...this.state }
    }

    handleMouseDown = name => {
        this.setState({
            ...this.state,
            [name]: 'text'
        })
    }

    handleMouseUp = name => {
        this.setState({
            ...this.state,
            [name]: 'password'
        })
    }

    onClosePro = () => {
        return false;
    }


    changeSftpPasswordAlert = () => {
        confirmAlert({
            childrenElement: () => <div />,
            customUI: ({ onClose }) => <ConfirmAlert
                header="Change Password"
                description="Are you sure you want to change the password?"
                onClosePro={onClose}
                onYes={this.handleChangePassword}
            />
        })
    }

    handleToggleButton = (toggle, name) => {
        this.setState({
            ...this.state,
            [name]: {
                ...this.state[name],
                value: !toggle
            }
        });
    }

    returnToggle = (toggleName) => {
        return (
            <span className={hasPermission('edit-configuration-settings') ? '' : 'disabledToggle'}>
                <ToggleButton
                    inactiveLabel={''}
                    activeLabel={''}
                    colors={themeCSSConstants.THUMBICONSTYLE}
                    trackStyle={themeCSSConstants.TRACKSTYLE}
                    thumbStyle={themeCSSConstants.THUMBSTYLE}
                    thumbAnimateRange={[4, 30]}
                    value={HF.convertToBool(this.state[toggleName].value)}
                    name={toggleName}
                    onToggle={(e) => this.handleToggleButton(e, toggleName)}
                />
            </span>
        )
    }

    componentDidMount() {
        const { brand_settings } = this.props;
        const stateVar = this.createBrandSettingsState(brand_settings);
        const { cron_job_setting } = brand_settings;
        let syncTimeProp = {
            time_duration: '',
            duration_type: '',
            syncDateLocale: undefined,
            startTimeLocale: undefined
        };
        if (cron_job_setting) {
            const time = cron_job_setting.sync_date_time_local.split(' ')[1];
            syncTimeProp = {
                time_duration: cron_job_setting.interval,
                duration_type: cron_job_setting.type,
                syncDateLocale: new Date(cron_job_setting.sync_date_time_local),
                startTimeLocale: moment(time, format),
            }

        }
        this.setState({
            ...stateVar,
            syncTime: syncTimeProp
        })

        this.props.provideCtrl({
            returnSftpState: () => this.returnSftpState()
        });
    }

    createBrandSettingsState = (brand_settings) => {
        let stateVar = cloneDeep(this.state);
        Object.keys(brand_settings).forEach((item, index) => {
            if (item in stateVar) {
                if (!Array.isArray(brand_settings[item])) {
                    if (typeof brand_settings[item] === 'object') {
                        stateVar = {
                            ...stateVar,
                            [item]: {
                                ...stateVar[item],
                                ...brand_settings[item]
                            }
                        }
                    }
                    else {
                        stateVar = {
                            ...stateVar,
                            [item]: brand_settings[item]
                        }
                    }
                }
                else if (brand_settings[item].length > 0) {
                    stateVar = {
                        ...stateVar,
                        [item]: brand_settings[item][0]
                    }
                }
            }
        });
        return stateVar;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.brand_settings !== prevProps.brand_settings) {
            const { brand_settings } = this.props;
            const stateVar = this.createBrandSettingsState(brand_settings);
            const { cron_job_setting } = brand_settings;
            let syncTimeProp = {
                time_duration: '',
                duration_type: '',
                syncDateLocale: undefined,
                startTimeLocale: undefined
            };
            if (cron_job_setting) {
                const time = cron_job_setting.sync_date_time_local.split(' ')[1];
                syncTimeProp = {
                    time_duration: cron_job_setting.interval,
                    duration_type: cron_job_setting.type,
                    syncDateLocale: new Date(cron_job_setting.sync_date_time_local),
                    startTimeLocale: moment(time, format),
                }

            }
            this.setState({
                ...stateVar,
                syncTime: syncTimeProp
            })
        }
    }

    handleChangePassword = () => {
        this.props.changeSftpPasswordCall({ user_name: this.state.user_name }).then(res => {
            if (res.status === 'success') {
                this.setState({
                    password: res.result.password
                })
            }
        });
    }

    saveTimeDuration = async (manualSync = false) => {
        if (this.validator.allValid() || manualSync) {
            let { syncTime, short_code } = this.state;
            let data = {};
            try {
            data = { ...syncTime };
            data.time_duration = syncTime.time_duration;
            data.duration_type = syncTime.duration_type;
            data.startTimeLocale =  syncTime.startTimeLocale ? syncTime.startTimeLocale._d : null;
            data.short_code = short_code;
            data.manually_run = manualSync;
                if ((syncTime.time_duration && syncTime.duration_type) || manualSync) {
                    const res = await brandService.updateBrandSyncTime(data);
                    this.props.successAlert(res.message)
                }
            } catch (e) {
                console.log("🚀 ~ file: SFTP_Configuration.jsx ~ line 263 ~ SFTP_Configuration ~ saveTimeDuration= ~ e", e)
                this.props.errorAlert(e)
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    timeDropdown = (selectedOption, info) => {
        this.setState({
            syncTime: {
                ...this.state.syncTime,
                duration_type: selectedOption.value
            }
        })
    }

    handleDatePicker = (date) => {
        this.setState({
            syncTime: {
                ...this.state.syncTime,
                syncDateUTC: moment.utc(date).format(),
                syncDateLocale: date,
                syncDateTimeUtc: moment.utc(date).format()
            }
        })
    }

    handleTimePicker = (timeObj) => {
        const time = timeObj;
        let initialdate = moment(this.state.syncTime.syncDateLocale).format('YYYY-MM-DD');
        let start_time = time ? time.format(format) + ':00' : '00:00:00';
        let startTimeLocale = time ? moment(time.format(format), format) : null;
        let datetimeA = moment(initialdate + " " + start_time);
        const utcTime = datetimeA.utc().format();
        this.setState({
            syncTime: {
                ...this.state.syncTime,
                startTimeLocale,
                syncDateTimeUtc: utcTime
            }
        })
    }

    render() {
        return (
            <div>
                <Col md={12} className="mt-xlg">
                    <div className="apiField larger">
                        SFTP Configuration
                    </div>

                    <React.Fragment>
                        <div className="row">
                            <div className="col-md-3 mt-lg text-right bordered col-md-offset-2">
                                <div className="settingsInfo">Host: </div>
                            </div>

                            <div className="col-md-5 mt-lg">
                                <div className="flexElem">
                                    <div className="block">
                                        <input className='form-control' type="text" name='host' value={process.env.REACT_APP_SFTP_HOST} onChange={this.handleInput} disabled={true} />
                                    </div>

                                    <div className="copyAction blank">
                                        <CopyToClipboard text={process.env.REACT_APP_SFTP_HOST}
                                            onCopy={() => this.setState({ copied: true })}>
                                            <span className="copyClipboard">&nbsp;</span>
                                        </CopyToClipboard>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3 mt-lg text-right bordered col-md-offset-2">
                                <div className="settingsInfo">Port:</div>
                            </div>

                            <div className="col-md-5 mt-lg">
                                <div className="flexElem">
                                    <div className="block">
                                        <input className='form-control' type="text" name='port' value={22} onChange={this.handleInput} disabled={true} />
                                    </div>
                                    <div className="copyAction blank">
                                        <CopyToClipboard text={'22'}
                                            onCopy={() => this.setState({ copied: true })}>
                                            <span className="copyClipboard">&nbsp;</span>
                                        </CopyToClipboard>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3 mt-lg text-right bordered col-md-offset-2">
                                <div className="settingsInfo">Product Feed Path:</div>
                            </div>

                            <div className="col-md-5 mt-lg">
                                <div className="flexElem">
                                    <div className="block">
                                        <input className='form-control' type="text" name='port' value={`${this.state.user_name}/${this.state.short_code}/product_feeds`} onChange={this.handleInput} disabled={true} />
                                        <span style={{ float: 'right' }}><i>(Upload file to Product_Feeds folder to sync PO/Style data.)</i></span>
                                    </div>

                                    <div className="copyAction blank">
                                        <CopyToClipboard text={`${this.state.user_name}/${this.state.short_code}/product_feeds`}
                                            onCopy={() => this.setState({ copied: true })}>
                                            <span className="copyClipboard">&nbsp;</span>
                                        </CopyToClipboard>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="row">
                            <div className="col-md-3 mt-lg text-right bordered col-md-offset-2">
                                <div className="settingsInfo">Lookup Feed Path:</div>
                            </div>

                            <div className="col-md-5 mt-lg">
                                <div className="flexElem">
                                    <div className="block">
                                        <input className='form-control' type="text" name='port' value={`${this.state.user_name}/${this.state.short_code}/lookup_feeds`} onChange={this.handleInput} disabled={true} />
                                        <span style={{ float: 'right' }}><i>(Upload file to Lookup_Feeds folder to sync lookup data.)</i></span>
                                    </div>

                                    <div className="copyAction blank">
                                        <CopyToClipboard text={`${this.state.user_name}/${this.state.short_code}/lookup_feeds`}
                                            onCopy={() => this.setState({ copied: true })}>
                                            <span className="copyClipboard">&nbsp;</span>
                                        </CopyToClipboard>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*  */}
                        <div className="row">
                            <div className="col-md-3 mt-lg text-right bordered col-md-offset-2">
                                <div className="settingsInfo">Username:</div>
                            </div>

                            <div className="col-md-5 mt-lg">
                                <div className="flexElem">
                                    <div className="block">
                                        <input className='form-control' type="text" name='sftp_user_name' value={this.state.user_name || ''} onChange={this.handleInput} disabled={true} />
                                    </div>

                                    <div className="copyAction blank">
                                        <CopyToClipboard text={this.state.user_name}
                                            onCopy={() => this.setState({ copied: true })}>
                                            <span className="copyClipboard">&nbsp;</span>
                                        </CopyToClipboard>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3 mt-lg text-right bordered col-md-offset-2">
                                <div className="settingsInfo">Password:</div>
                            </div>

                            <div className="col-md-5 mt-lg">
                                <div className="flexElem">
                                    <div className="passwordShow block">
                                        <input type={this.state.password_type} autoComplete="off" name="password" className="form-control pr-xlg password_icon" value={this.state.password ? this.state.password : ''} onChange={this.handleInput} minLength="6" disabled={hasPermission('edit-configuration-settings') ? false : true} disabled />

                                        <span className="showPass iconsClearfix" name='password_type' onMouseDown={e => { this.handleMouseDown('password_type') }} onMouseUp={(e) => { this.handleMouseUp('password_type') }} onMouseOut={(e) => { this.handleMouseUp('password_type') }}>
                                            <FiEye name='password' />
                                        </span>
                                        {
                                            hasPermission('change-sftp-password') &&
                                            <span style={{ float: 'right' }}>
                                                <button className="smallActionBtn mt-sm btnDefault" onClick={this.changeSftpPasswordAlert}>Generate New Password</button>
                                            </span>
                                        }
                                    </div>

                                    <div className="copyAction blank">
                                        <CopyToClipboard text={this.state.password}
                                            onCopy={() => this.setState({ copied: true })}>
                                            <span className="copyClipboard">&nbsp;</span>
                                        </CopyToClipboard>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-md-3 mt-lg text-right bordered col-md-offset-2">
                                <div className="settingsInfo">Sync Interval</div>
                            </div>

                            <div className="col-md-5 mt-lg">
                                <div className="row">
                                    <div className="col-sm-12 col-md-6">
                                        <input className="form-control"
                                            type="text"
                                            maxLength={3}
                                            placeholder="Enter Time From 1 To 9"
                                            value={this.state.syncTime.time_duration}
                                            onChange={(e) => {
                                                this.setState({
                                                    syncTime: {
                                                        ...this.state.syncTime,
                                                        time_duration: e.target.value.replace(/[^0-9\.]+/g, '')
                                                    }
                                                })
                                            }}
                                        />
                                        {this.validator.message('Duration', this.state.syncTime.time_duration, 'required')}
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        <Select
                                            value={HF.returnLabelWithValue(this.state.syncTime.duration_type, timeTypes)}
                                            onChange={this.timeDropdown}
                                            options={timeTypes}
                                            isSearchable={false}
                                            name='timeDuration'
                                            placeholder={'Time Duration'}
                                        />
                                        {this.validator.message('Duration Type', this.state.syncTime.duration_type, 'required')}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3 mt-lg text-right bordered col-md-offset-2">
                                <div className="settingsInfo">Schedule Starts at: </div>
                            </div>
                            <div className="col-md-5 mt-lg">
                                <div className="row">
                                    <div className="col-sm-12 col-md-6">
                                        <DatePicker
                                            className="form-control"
                                            value={this.state.syncTime.syncDateLocale}
                                            onChange={this.handleDatePicker}
                                            placeholderText={`11/06/2022`}
                                            minDate={new Date()}
                                        />
                                        {this.validator.message('Start Date', this.state.syncTime.syncDateLocale, 'required')}
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        <TimePicker
                                            showSecond={false}
                                            className="form-control"
                                            defaultValue={now}
                                            value={this.state.syncTime.startTimeLocale}
                                            onChange={this.handleTimePicker}
                                            format={format}
                                            use12Hours
                                            inputReadOnly
                                        />
                                        {this.validator.message('Start Time', this.state.syncTime.startTimeLocale, 'required')}
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3 mt-lg text-right bordered col-md-offset-2">
                                {/* <div className="settingsInfo">Time in UTC: </div> */}
                            </div>
                            <div className="col-md-5 mt-lg">
                                <div className="row">
                                    <div className="col-sm-12 col-md-6">
                                        {/* <div className="form-control" style={{ padding: 10 }}>{this.state.syncTime.syncDate ? this.state.syncTime.syncDateTime.replace('T', '\t') : 'N/A'} </div> */}
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        <button className="customBtn btnBlue "
                                            style={{
                                                height: '45px', minWidth: '100%'
                                            }}
                                            type="button"
                                            onClick={() => { this.saveTimeDuration(false) }}
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-md-3 mt-lg text-right bordered col-md-offset-2">
                                <div className="settingsInfo">Sync Job:</div>
                            </div>

                            <div className="col-md-5 mt-lg">
                                <div className="flexElem">
                                    <button className="customBtn btnBlue"
                                        type="button"
                                        onClick={() => { this.saveTimeDuration(true) }}
                                    >Sync Now</button>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>

                </Col>

                <Col md={12} className="mt-xlg">
                    <div className="apiField larger">
                        Data Feed Sync Settings
                    </div>

                    <React.Fragment>

                        <div className="row">
                            <div className="col-md-5 mt-lg col-md-offset-3">
                                <div className="settingsInfo">
                                    Sync is Active?
                                </div>
                            </div>

                            <div className="col-md-1 mt-lg text-center">
                                <div className="settingsInfo">
                                    {
                                        this.returnToggle('sync_is_active')
                                    }
                                </div>
                            </div>
                        </div>

                        {/* <div className="row">
                            <div className="col-md-5 mt-lg col-md-offset-3">
                                <div className="settingsInfo">
                                    Update file extension before syncing?
                                                        </div>
                            </div>
                            <div className="col-md-1 mt-lg text-center">
                                <div className="settingsInfo">
                                    {
                                        this.returnToggle('update_file_extension')
                                    }
                                </div>
                            </div>
                        </div> */}


                        <div className="row">
                            <div className="col-md-5 mt-lg col-md-offset-3">
                                <div className="settingsInfo">
                                    Turcate data before syncing?
                                </div>
                            </div>

                            <div className="col-md-1 mt-lg text-center">
                                <div className="settingsInfo">
                                    {
                                        this.returnToggle('truncate_before_syncing')
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-5 mt-lg col-md-offset-3">
                                <div className="settingsInfo">
                                    Syncing lookup tables?
                                </div>
                            </div>

                            <div className="col-md-1 mt-lg text-center">
                                <div className="settingsInfo">
                                    {
                                        this.returnToggle('syncing_lookup_tables')
                                    }

                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                </Col>
            </div>
        )
    }
}

SFTP_Configuration.defaultProps = {
    brand_settings: {
        user_name: '',
        password: '',
        short_code: '',
        cron_job_setting: {}
    }
}


const mapDispatchToProps = dispatch => {
    return ({
        changeSftpPasswordCall: (data) => { return dispatch(brandActions.changeSftpPassword(data)) },
        errorAlert: (e) => {
            dispatch(alertActions.error(e))
        },
        successAlert: (msg) => {
            dispatch(alertActions.success(msg))
        },
    });
};

function mapStateToProps(state) {
    const { brand_settings } = state.brandReducer;
    return {
        brand_settings
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SFTP_Configuration);



// WEBPACK FOOTER //
// ./src/components/Admin/Settings/SFTP_Configuration.jsx